// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../graphql/api/index';

import { CustomerRegistrationResponseFragmentDoc } from '../../../graphql/api/auth/fragments/customerRegistrationResponse.generated';
import { LoginResponseSuccessFragmentDoc } from '../../../graphql/api/auth/fragments/loginResponseSuccess.generated';
import { MeFragmentDoc } from '../../../graphql/api/fragments/me.fragment.generated';
import { CostumerConsultantFragmentDoc } from '../../../graphql/api/fragments/costumerConsultant.fragment.generated';
export const EnquiryResponseNewCustomerFragmentDoc = `
    fragment enquiryResponseNewCustomer on EnquiryResponseNewCustomer {
  __typename
  customer {
    ...customerRegistrationResponse
  }
}
    `;